"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileToolFieldView = exports.Styles = exports.CSS = void 0;
const theme_1 = require("../../../components/theme");
const i18n_1 = require("../../../i18n");
const mithril_1 = require("../../../mithril");
const field_info_1 = require("../../field.info/field.info");
exports.CSS = {
    file: 'c-FileTool__file',
    form: 'c-FileTool__form',
    container: 'c-FileTool__container',
    active: 'c-Filetool__active',
};
exports.Styles = {
    [exports.CSS.file]: {
        display: 'none',
    },
    [exports.CSS.form]: {
        width: '100%',
        height: '100%',
    },
    [exports.CSS.container]: {
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        border: '1px solid ' + theme_1.DefaultTheme.font.color.disabled,
        '&:hover': {
            border: '1px solid ' + theme_1.DefaultTheme.color.accent,
            cursor: 'pointer',
        },
    },
    [exports.CSS.active]: {
        border: '1px solid ' + theme_1.DefaultTheme.color.accent,
    },
};
(0, theme_1.addStyles)(exports.Styles);
exports.FileToolFieldView = {
    viewInline(field) {
        return field.displayValue;
    },
    hasDetail(field) {
        return !!field.displayValue;
    },
    viewDetail(field) {
        if (!exports.FileToolFieldView.hasDetail(field)) {
            return null;
        }
        const result = [];
        result.push(field_info_1.FieldInfo.viewStat(i18n_1.T.FIELD_FILE_TOOL_FILE_SIZE, formatBytes(field.stateValue.size)));
        Object.keys(field.stateValue.metadata).forEach((key) => {
            result.push(field_info_1.FieldInfo.viewStat(key, field.stateValue.metadata[key]));
        });
        return mithril_1.m.fragment({}, result);
    },
    viewEdit(field, ctrl) {
        if (field.displayValue) {
            return (0, mithril_1.m)('div', [field.displayValue]);
        }
        if (ctrl.fieldsInLoadingState.length > 0) {
            return (0, mithril_1.m)('form', { className: exports.CSS.form }, [
                (0, mithril_1.m)('div', {
                    className: exports.CSS.container,
                    disabled: true,
                }, [(0, i18n_1.Translate)(i18n_1.T.DRAG_FILE)]),
            ]);
        }
        return (0, mithril_1.m)('form', { className: exports.CSS.form }, [
            (0, mithril_1.m)('input', { className: exports.CSS.file, type: 'file', id: field.id, onchange: (e) => ctrl.onFile(e, field) }, ''),
            (0, mithril_1.m)('div', {
                id: `drag-area-${field.id}`,
                className: exports.CSS.container,
                onclick: (e) => ctrl.openFileDialog(e, field),
                ondragover: (e) => ctrl.onDragOver(e, field),
                ondragleave: (e) => ctrl.onDragLeave(e, field),
                ondragend: (e) => ctrl.onDragEnd(e, field),
                ondrop: (e) => ctrl.update(e, field),
            }, [(0, i18n_1.Translate)(i18n_1.T.DRAG_FILE)]),
        ]);
    },
    hasClear(field) {
        return !!field.displayValue;
    },
    hasFile(field) {
        return !!field.displayValue;
    },
};
function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
        return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
//# sourceMappingURL=file.tool.field.view.js.map